import request from 'utils/request'

export const getMCAXS451InitRequest = () =>
  request({
    url: '/MCAXS451/init',
    method: 'post',
  })
